import { useStartAPetitionPageData, useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';

type PageState = ReturnType<typeof useStartAPetitionPageState>;
type FlowId = NonNullable<NonNullable<NonNullable<PageState['data']['draft']>['metadata']>['variant']>;
type Result = ModelHookResult<
	{
		flowId: FlowId;
		/** Intro runs the campaign version when the FCM is on for this locale and the link has the campaign param. */
		shouldShowMelonesCampaign: boolean;
		/** Edit runs the AI text labeling step experiment: it's running for this user (any group), so it owns the step. */
		shouldShowAiTextLabeling: boolean;
		/** Edit runs the decision-maker step experiment: the draft qualifies for inference; unset (not known yet, or location inference failed) counts as not. */
		shouldShowDecisionMakers: boolean;
	},
	{ matches: PageState['actions']['matches'] }
>;

export function usePageBody(): Result {
	const { data, actions } = useStartAPetitionPageState();
	const {
		data: {
			experiments,
			featureConfigs: { sapIntroCampaignMelones },
		},
	} = useStartAPetitionPageData();
	const campaignParam = useQueryParamValue('sap_campaign');

	return {
		data: {
			flowId: data.draft?.metadata?.variant ?? 'control',
			shouldShowMelonesCampaign: sapIntroCampaignMelones.enabled && campaignParam === 'melones',
			shouldShowAiTextLabeling: !experiments.sapAiTextLabeling.fallback,
			shouldShowDecisionMakers: !!data.draft?.metadata?.decisionMakers?.eligible,
		},
		actions: { matches: actions.matches },
	};
}
